/*
 * Equirectangular projection for the guess map, plus the land test that round
 * generation uses to avoid dropping players in the middle of an ocean.
 *
 * Equirectangular is chosen over anything prettier because it inverts in one
 * line: a click has to become a lat/lon, and every other projection would need
 * an iterative solve to get back.
 */

export function lonLatToXY(lon, lat, width, height) {
  return {
    x: ((lon + 180) / 360) * width,
    y: ((90 - lat) / 180) * height
  };
}

export function xyToLonLat(x, y, width, height) {
  return {
    lon: (x / width) * 360 - 180,
    lat: 90 - (y / height) * 180
  };
}

/*
 * Even-odd ray casting against every ring at once. Holes need no special
 * handling: a point inside a landmass and inside that landmass's lake crosses
 * two boundaries and so comes out even, i.e. water.
 */
export function pointOnLand(lat, lon, rings) {
  let inside = false;

  for (const ring of rings) {
    for (let i = 0, j = ring.length - 1; i < ring.length; j = i, i += 1) {
      const [xi, yi] = ring[i];
      const [xj, yj] = ring[j];

      if (yi > lat !== yj > lat && lon < ((xj - xi) * (lat - yi)) / (yj - yi) + xi) {
        inside = !inside;
      }
    }
  }

  return inside;
}

export function svgPathForRings(rings, width, height) {
  return rings
    .map((ring) => {
      const points = ring.map(([lon, lat]) => {
        const { x, y } = lonLatToXY(lon, lat, width, height);
        return `${x.toFixed(1)},${y.toFixed(1)}`;
      });
      return `M${points.join('L')}Z`;
    })
    .join('');
}
